module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_02-32e79f25fb9bbad9e30bb8ef9e3f1f74.jpg";